import Presentation                                            from "./presentation";
import { getNotificationSettings, updateNotificationSettings } from "_services/api/user";
import useSWR                                                  from "swr";
import { useEffect, useState }                                 from "react";
import Toast                                                   from "_common/toast";

const fetcher = async () => {
	const res = await getNotificationSettings ();

	return res;
};

// because backend sends empty array response for new users
const initialSettingState = [
	{
		"enabled" : 1,
		"name"    : "achievements"
	},
	{
		"enabled" : 1,
		"name"    : "alerts"
	},
	{
		"enabled" : 1,
		"name"    : "coins_added"
	},
	{
		"enabled" : 1,
		"name"    : "comments_on_your_post"
	},
	{
		"enabled" : 1,
		"name"    : "daily_growth_reports"
	},
	{
		"enabled" : 1,
		"name"    : "diamonds_added"
	},
	{
		"enabled" : 1,
		"name"    : "likes_on_your_post"
	},
	{
		"enabled" : 1,
		"name"    : "new_followers"
	},
	{
		"enabled" : 1,
		"name"    : "recommendations"
	},
	{
		"enabled" : 1,
		"name"    : "shares_on_your_post"
	},
	{
		"enabled" : 1,
		"name"    : "stream_summary"
	},
	{
		"enabled" : 1,
		"name"    : "subscribed"
	}
];

const component = props => {
	const { handleSettingsClose } = props;

	const settingsPayload = { "settings": [] };
	const { settings }    = settingsPayload;

	const { data, error: settingsError }                    = useSWR ( "notification-settings", fetcher );
	const [ notificationSettings, setNotificationSettings ] = useState ( null );

	useEffect ( () => {
		if ( !data?.length ) {
			const mappedNotificationSettings = mapSettings ( initialSettingState );

			setNotificationSettings ( mappedNotificationSettings );

			return;
		}

		const mappedNotificationSettings = mapSettings ( data );

		setNotificationSettings ( mappedNotificationSettings );

	}, [ data ] );

	const mapSettings = data => {
		return data.reduce ( ( acc, item ) => {
			acc[item.name] = { name: item.name, enabledState: item.enabled };

			return acc;
		}, {} );
	};

	// first update the settings then send the full data to do post request
	const mapSaveSettings = notificationSettings => {
		Object.keys ( notificationSettings )
			.forEach ( key => settings.push ( { key: notificationSettings[key].name, enabled: notificationSettings[key].enabledState } ) );

	};

	if ( settingsError ) {
		return null;
	}

	const updateNotificationStates = ( type, value ) => {
		const val = value === 1 ? 0 : 1; // toggling the enabledState

		setNotificationSettings ( { ...notificationSettings, [type]: { name: type, enabledState: val } } );
	};

	const saveNotificationSettings = async () => {
		// we need to send the POST request in the format mentioned in below mapping function
		mapSaveSettings ( notificationSettings );

		try {
			await updateNotificationSettings ( settingsPayload );
			Toast.success ( "Settings have been saved." );
			handleSettingsClose ();
		} catch ( e ) {
			Toast.error ( e.displayMsg );
		}

	};

	return (
		<Presentation
			handleSettingsClose      = { handleSettingsClose }
			notificationSettings     = { notificationSettings }
			saveNotificationSettings = { saveNotificationSettings }
			updateNotificationStates = { updateNotificationStates }
		/>
	);
};

export default component;